var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"exit-review-button",on:{"click":_vm.exitReview}},[_vm._v("\n  "+_vm._s(_vm.$roleAwareness.isGuestUser ? 'HOMEPAGE' :'EXIT REVIEW')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }